'use client'
import { useEffect, useState } from "react";

const useDeviceType = () => {
  const [isIOS, setIsIOS] = useState(false);
  const [isAndroid, setIsAndroid] = useState(false);

  useEffect(() => {
    if (typeof navigator !== "undefined") {
      const userAgent = navigator.userAgent || navigator.vendor;
      setIsIOS(/iPad|iPhone|iPod/.test(userAgent));
      setIsAndroid(/android/i.test(userAgent));
    }
  }, []);

  return { isIOS, isAndroid };
};

export default useDeviceType;
